var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import DialogFooter from '../Dialogs/DialogFooter';

/**
 * The `PanelContent` component is for displaying the expanded content
 * for an `ExpansionPanel`. It will display any children in a `md-panel-content`
 * container followed by a `Divider` and the `PanelControls` .
 */

var PanelContent = function (_PureComponent) {
  _inherits(PanelContent, _PureComponent);
  function PanelContent() {
    _classCallCheck(this, PanelContent);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  PanelContent.prototype.render = function render() {
    var _props = this.props,
      style = _props.style,
      footerStyle = _props.footerStyle,
      footerClassName = _props.footerClassName,
      contentStyle = _props.contentStyle,
      className = _props.className,
      children = _props.children,
      onSave = _props.onSave,
      onCancel = _props.onCancel,
      saveProps = _props.saveProps,
      saveType = _props.saveType,
      saveLabel = _props.saveLabel,
      savePrimary = _props.savePrimary,
      saveSecondary = _props.saveSecondary,
      cancelProps = _props.cancelProps,
      cancelType = _props.cancelType,
      cancelLabel = _props.cancelLabel,
      cancelPrimary = _props.cancelPrimary,
      cancelSecondary = _props.cancelSecondary,
      footer = _props.footer,
      footerChildren = _props.footerChildren;
    var actions = [_extends({
      type: cancelType,
      label: cancelLabel,
      primary: cancelPrimary,
      secondary: cancelSecondary
    }, cancelProps, {
      onClick: onCancel
    }), _extends({
      type: saveType,
      label: saveLabel,
      primary: savePrimary,
      secondary: saveSecondary
    }, saveProps, {
      onClick: onSave
    })];
    var actionFooter = null;
    if (typeof footer === 'undefined') {
      actionFooter = React.createElement(DialogFooter, {
        actions: actions,
        style: footerStyle,
        className: cn('md-divider-border md-divider-border--top', footerClassName)
      }, footerChildren);
    } else if (footer !== null) {
      actionFooter = footer;
    }
    return React.createElement('div', {
      style: style
    }, React.createElement('div', {
      className: cn('md-panel-content', className),
      style: contentStyle
    }, children), actionFooter);
  };
  return PanelContent;
}(PureComponent);
PanelContent.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  footerStyle: PropTypes.object,
  footerClassName: PropTypes.string,
  contentStyle: PropTypes.object,
  children: PropTypes.node,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saveProps: PropTypes.object,
  saveType: PropTypes.string,
  saveLabel: PropTypes.node.isRequired,
  savePrimary: PropTypes.bool,
  saveSecondary: PropTypes.bool,
  cancelProps: PropTypes.object,
  cancelType: PropTypes.string,
  cancelLabel: PropTypes.node.isRequired,
  cancelPrimary: PropTypes.bool,
  cancelSecondary: PropTypes.bool,
  footer: PropTypes.node,
  footerChildren: PropTypes.node
};
export default PanelContent;